<template>
  <span class="flex-container flex-row" :class=" { 'reversed-color' : reversed } ">
    <input type="checkbox" :id="itemId" v-model="getItemByID(itemId).status" :disabled="itemDisabled">
    <label :for="itemId" :class="[{ checked: getItemByID(itemId).status }, { nospanresponsive: responsiveLabel }, flexClasses]">
      <span v-if="hasLabel===true" :class="{ responsivespan: responsiveLabel }">
        <span>{{labelOutput}}</span>
      </span>
    </label>
  </span>
</template>

<script>

export default {
  name: 'Checkbox',
  props: {
    itemId: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: 'hinzufügen',
      required: false
    },
    labelActive: {
      type: String,
      default: 'hinzugefügt',
      required: false
    },
    hasLabel: {
      type: Boolean,
      default: true,
      required: false
    },
    responsiveLabel: {
      type: Boolean,
      default: false,
      required: false
    },
    itemDisabled: {
      type: Boolean,
      default: false,
      required: false
    },
    reversed: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function () {
    return {
      flexClasses: 'flex-container flex-row align-items-center swiper-no-swiping'
    }
  },
  computed: {
    labelOutput: function () {
      if (this.getItemByID(this.itemId).status === true) {
        return this.labelActive
      } else {
        return this.label
      }
    }
  },
  methods: {
    getItemByID: function (itemId) {
      return this.$root.getItemByID(itemId)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/css/variables.scss";

input {
  display: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  outline: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  box-sizing: border-box;
  padding: 0;
  border:none;
}

input:focus{
  outline:0;
}

label {
  color:$secondaryFontColor;
  font-size: 18px;
  font-weight: 600;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  position: relative;
  margin: 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

label:hover {
  cursor: pointer;
}

input:disabled + label:hover {
  cursor: not-allowed;
}

/* spur */
label:before {
  content: '';
  display: block;
  /*
  width: 49px;
  height: 28px;
  */
  width: 52px;
  height: 32px;
  background: #d9d9d9;
  /*
  border-radius: 14px;
  */
  border-radius: 16px;
  margin-right: 8px;
  box-shadow: none;
  background-origin: border-box;
  background-clip: border-box;
  transition-timing-function: ease-in-out;
  transition-duration: 0.2s;
}

/* regler */
label:after {
  content: '';
  /*
  width: 22px;
  height: 22px;
  */
  width:24px;
  height: 24px;
  border-radius: 12px;
  background-color:#FDFDFD;
  display: block;
  border: 2px solid #FAFAFA;
  position: absolute;
  /*
  left:3px;
  top:3px;
  */
  left:5px;
  top:4px;
  box-shadow: 0px 1px 3px 0 rgba(0,0,0,0.2);
  transition-timing-function: ease-in-out;
  transition-duration: 0.2s;
  display: block;
}

label.checked {
  color: #1a1a1a;
}

label.checked:before {
  /*
  box-shadow: inset 0 0 0 15px $primaryColor;
  */
  box-shadow: inset 0 0 0 18px $primaryColor;
}

label.checked:after {
  color:#1a1a1a;
  left:23px;
}

label span {
  line-height: 1;
}

.responsivespan {
  display: none;
}
.nospanresponsive:before {
  margin-right: 0;
}
@media(min-width: 520px) {
  .responsivespan {
    display: block;
  }
  .nospanresponsive:before {
    margin-right: 8px;
  }
}

.reversed-color {
  label {
    &:before {
      opacity: 0.9;
    }
    span {
      color: #eee;
    }
  }
  label.checked {
    &:before {
      opacity: 1;
      box-shadow: inset 0 0 0 18px #fff;
    }
    &:after {
      background: $primaryColor;
      border-color: #5372F9;
    }
    span {
      color: #fff;
    }
  }
}
</style>
